export default "__VITE_ASSET__CbkPHys9__"